import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import 'bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import '@/assets/css/modern.css'
import '@/assets/css/base.css'
import shareds from '@/assets/js/shared'
import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
const shared = new shareds()
const app = createApp(App);
app.config.globalProperties.$shared = shared;
const apiService = new ApiService(app);
app.config.globalProperties.$api = apiService;

//正式環境關閉console.log
if ( 
    process.env.VUE_APP_TEST_ENV == 'production'
){
    window.console.log = ()=>{}
};

app.use(i18n)
app.use(store)
app.use(router)
app.mount('#app');
